import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, CalendarDaysIcon, ExternalLinkIcon, PartyPopperIcon } from 'lucide-react';
import { BadgeDivider } from './Badge';
export function Shows() {
  return <section id="shows" className="relative w-full bg-[var(--vu-black)] py-20 px-5 overflow-hidden grain" data-id="element-80" data-mp="2ylr5yprlmw3x">
      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-81" data-mp="2ulysbynclzrp">
        <p className="font-cond uppercase tracking-[0.4em] text-[var(--vu-gold)] text-xs mb-2" data-id="element-82" data-mp="26wnzr4g5jbon">
          On The Marquee
        </p>
        <h2 className="font-display uppercase text-[var(--vu-cream)] text-5xl sm:text-6xl leading-none" data-id="element-83" data-mp="21ycocpa7kt4b">
          Catch Us Live
        </h2>
        <BadgeDivider label="♬" data-id="element-84" data-mp="2axg8lwl43eke" />

        {/* Marquee flyer for the recurring residency */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="relative bg-[var(--vu-red)] text-[var(--vu-cream)] border-4 border-[var(--vu-gold)] shadow-[8px_8px_0_0_var(--vu-navy)] px-6 py-10 mt-4" data-id="element-85" data-mp="1n7dktso8curl">
          <div className="absolute inset-2 border border-[var(--vu-cream)]/30 pointer-events-none" data-id="element-86" data-mp="320censn45zjb" />
          <p className="font-cond uppercase tracking-[0.4em] text-[var(--vu-gold)] text-xs" data-id="element-87" data-mp="36tnjxpca2894">
            Residency
          </p>
          <h3 className="font-display uppercase text-5xl sm:text-7xl leading-none mt-2" data-id="element-88" data-mp="2e481wfm73f3p">
            Twisted Tiki
          </h3>
          <div className="mt-4 flex flex-col sm:flex-row items-center justify-center gap-x-6 gap-y-2 font-cond uppercase tracking-wider text-sm" data-id="element-89" data-mp="2j2hxusfqujqd">
            <span className="flex items-center gap-2" data-id="element-90" data-mp="2o4h204jb5kod">
              <MapPinIcon className="w-4 h-4 text-[var(--vu-gold)]" data-id="element-91" data-mp="2t2ihkfhiz1v3" />
              Corey Ave, St. Pete Beach
            </span>
            <span className="flex items-center gap-2" data-id="element-92" data-mp="3bvnnyr3z254">
              <CalendarDaysIcon className="w-4 h-4 text-[var(--vu-gold)]" data-id="element-93" data-mp="8aqdvlrensz9" />
              Recurring Live Sets
            </span>
          </div>
        </motion.div>

        {/* Private events + booking */}
        <div className="mt-10 bg-[var(--vu-navy)] border-2 border-[var(--vu-gold)]/40 p-8" data-id="element-94" data-mp="1zg32hccc12qb">
          <PartyPopperIcon className="w-8 h-8 text-[var(--vu-gold)] mx-auto" data-id="element-95" data-mp="2dfkus1ou6y4f" />
          <p className="mt-3 font-body text-[var(--vu-cream)]/85 text-base leading-relaxed" data-id="element-96" data-mp="29dhhd7ilxjgi">
            We also play <strong className="text-[var(--vu-cream)]" data-id="element-97" data-mp="1lnn6gvhum4yw">private events, weddings,
            and corporate parties.</strong> Bookings start at{' '}
            <span className="text-[var(--vu-gold)] font-cond" data-id="element-98" data-mp="1gqdcd2jil54q">$1,200 / event.</span>
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-4" data-id="element-99" data-mp="1uhruz89if4b9">
            <a href="https://www.thebash.com/acoustic-guitar/nick-sette" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[var(--vu-gold)] text-[var(--vu-black)] font-display uppercase tracking-wider px-7 py-3 border-2 border-[var(--vu-black)] shadow-[4px_4px_0_0_var(--vu-black)] hover:shadow-[1px_1px_0_0_var(--vu-black)] hover:translate-x-[3px] hover:translate-y-[3px] transition-all" data-id="element-100" data-mp="1pp8fu6v6c14c">
              Book Us on The Bash
              <ExternalLinkIcon className="w-4 h-4" data-id="element-101" data-mp="dxrcjomt2325" />
            </a>
            <a href="https://gotonight.com/profile/?artistId=244686" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[var(--vu-gold)] text-[var(--vu-black)] font-display uppercase tracking-wider px-7 py-3 border-2 border-[var(--vu-black)] shadow-[4px_4px_0_0_var(--vu-black)] hover:shadow-[1px_1px_0_0_var(--vu-black)] hover:translate-x-[3px] hover:translate-y-[3px] transition-all" data-id="element-102" data-mp="iuhrg8mvislz">
              Find Us on GoTonight
              <ExternalLinkIcon className="w-4 h-4" data-id="element-103" data-mp="3hbdagv1sx07w" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}